export default __webpack_public_path__ + "static/media/review_intro.aaf2baa9.png";